var map = {
	"./Stage_4_Atmo.jpg": "6295",
	"./Stage_5_Atmo.jpg": "ec99",
	"./Stage_6_Atmo.jpg": "fbe1",
	"./Stage_7_Atmo.jpg": "84fa",
	"./Stage_8_Atmo.jpg": "8ebd",
	"./Stage_9_Atmo.jpg": "fe7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c756";